/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'security';
const componentName = 'geo-db-mapping-modal';
const prefix = `${moduleName}.${componentName}`;

export const geoDbMappingElementModalTitle = `${prefix}.geoDbMappingElementModalTitle`;
export const sectionTitleGeneral = `${prefix}.sectionTitleGeneral`;
export const attributeLabel = `${prefix}.attributeLabel`;
export const attributePlaceholder = `${prefix}.attributePlaceholder`;
export const valuesLabel = `${prefix}.valuesLabel`;
export const valuesPlaceholder = `${prefix}.valuesPlaceholder`;

export const ENGLISH = {
    [geoDbMappingElementModalTitle]: 'Add Element',
    [sectionTitleGeneral]: 'General',
    [attributeLabel]: 'Attribute',
    [attributePlaceholder]: 'Select Attribute',
    [valuesLabel]: 'Values',
    [valuesPlaceholder]: 'Enter Values',
};
